import { render, staticRenderFns } from "./paymentMethod.vue?vue&type=template&id=d1f4f1dc&"
import script from "./paymentMethod.vue?vue&type=script&lang=js&"
export * from "./paymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1f4f1dc')) {
      api.createRecord('d1f4f1dc', component.options)
    } else {
      api.reload('d1f4f1dc', component.options)
    }
    module.hot.accept("./paymentMethod.vue?vue&type=template&id=d1f4f1dc&", function () {
      api.rerender('d1f4f1dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/paymentMethod.vue"
export default component.exports